<template>
  <!-- 培训课程 -->
  <div class="template-list main-container">
    <div class="main-panel">
      <div class="search-box btn3" :class="{ close: !searchMore }">
        <div class="input-item">
          <span class="label">课程名称</span>
          <Input v-model="search.name" clearable placeholder="请输入" />
        </div>
        <div class="input-item" v-if="menuList && menuList.length">
          <span class="label">课程分类</span>
          <Select v-model="search.articleColumnId" clearable transfer filterable>
            <Option :value="item.id" v-for="(item, index) in menuList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">课程类型</span>
          <Select v-model="search.articleType" clearable transfer filterable>
            <Option :value="key" v-for="(item, key) in articleType" :key="key">{{ item }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">展示机构</span>
          <selectTree type="4" status="1" v-model="search.orgId"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">是否可分享</span>
          <RadioGroup v-model="search.isShare" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否上架</span>
          <RadioGroup v-model="search.isUse" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="1">上架</Radio>
            <Radio label="0">下架</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">关联产品</span>
          <Select :label-in-value="true" v-model="search.productCodeList" placeholder="请选择" clearable transfer filterable multiple>
            <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{ product.productName }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">来源</span>
          <Select v-model="search.sourceFrom" clearable transfer filterable>
            <Option :value="0">素材库</Option>
            <Option :value="1">自建</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">上架时间</span>
          <DatePicker v-model="search.time" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="请选择" separator="至"></DatePicker>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="searchAjax(1)">查询</Button>
          <Button type="primary" @click="reset" ghost>重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore = true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>

      <div class="btn-box">
        <div class="del-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部课程</Checkbox>
          <Button type="primary" @click="batchDelete" ghost v-if="$units.pointAction('content_4_1_4')">批量删除</Button>
        </div>

        <Button type="primary" @click="openTemplateEdit({})" v-if="$units.pointAction('content_4_1_1')">新增</Button>
        <Button type="warning" @click="toPublicMaterialsPage()" v-if="$units.pointAction('content_4_1_5')">从公共素材库导入</Button>

        <div class="switch" v-if="$units.pointAction('content_4_1_6')">
          平台新内容自动同步
          <i-switch
            size="large"
            true-value="1"
            false-value="0"
            class="i-switch"
            v-model="formData.autoSync"
            @on-change="changeSync"
            :disabled="formData.id ? false : true"
          >
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
          <a class="config-text" @click="$refs.config.open()">配置</a>
        </div>
      </div>

      <div class="amount-num">
        <span class="text"
          >已选择<span class="num">{{ isAll ? total : selectArr.length }}</span
          >项,共<span class="num">{{ total }}</span
          >项课程</span
        >
      </div>

      <div class="table-box template-table">
        <loading :isShow="tableLoading" />
        <Table row-key="id" :columns="columns" :data="tableData" border @on-selection-change="onSelectChange" :indent-size="6">
          <template slot-scope="{ row }" slot="name">
            <span class="name" @click="preview(row)">{{ row.name }}</span>
          </template>

          <template slot-scope="{ row }" slot="articleType">
            <span>{{ articleType[row.articleType] }}</span>
          </template>
          <template slot-scope="{ row }" slot="isShare">
            <i-switch
              v-if="!row.parentId"
              v-model="row.isShare"
              size="large"
              true-value="1"
              false-value="0"
              style="margin-left: 5px; min-width: 55px"
              @on-change="changeShare(row)"
            >
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
            <span v-else>-</span>
          </template>

          <template slot-scope="{ row }" slot="isUse">
            <i-switch
              :disabled="disabledMethod(row)"
              v-model="row.isUse"
              size="large"
              true-value="1"
              false-value="0"
              style="margin-left: 5px; min-width: 55px"
              @on-change="changeUse(row)"
            >
              <span slot="open">上架</span>
              <span slot="close">下架</span>
            </i-switch>
          </template>

          <template slot-scope="{ row }" slot="action">
            <div>
              <span class="table-btn" @click="openTemplateEdit(row)" v-if="$units.pointAction('content_4_1_2')">编辑</span>
              <span v-if="$units.pointAction('content_4_1_3')&&!row.parentId" class="table-btn" @click="$refs.editTest.open(row)">题目配置</span>
              <span v-if="$units.pointAction('content_4_1_1') && !row.parentId && row.articleType == 2" class="table-btn" @click="row.articleType == 2 && addChildrenTemplate(row)">新建子课程</span>
              <span class="table-btn red" @click="delTemplate(row)" v-if="$units.pointAction('content_4_1_4')">删除</span>
            </div>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
      </div>
    </div>

    <!-- 模板新增、编辑 -->
    <editCourse ref="editCourse" @reload="getList" :articleTypeList="articleTypeList"></editCourse>

    <editTest ref="editTest"></editTest>

    <!-- 配置 -->
    <auto-sync-config ref="config" @reload="getAutoSyncDetail"></auto-sync-config>

    <!-- excel预览 -->
    <Modal v-model="excelModal" title="课程文件" width="650" :footer-hide="true" class="my-modal top p-b">
			<Table :columns="excelColumns" :data="excelTableData" border style="margin-top: 15px;">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="downloadExcel(row)">下载</span>
        </template>
      </Table>
		</Modal>
  </div>
</template>

<script>
import { filterTime } from '@/api/filter';
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import editCourse from './components/editCourse';
import editTest from './components/editTest';
import autoSyncConfig from './components/autoSyncConfig';

export default {
  mixins: [pageTool, common],
  components: {
    editCourse,
    selectTree,
    editTest,
    autoSyncConfig
  },
  data() {
    return {
      articleType: {}, //课程类型
      articleTypeList: [], //课程类型列表
      menuList: [],
      menuTypeList: [],
      productListArr: [],
      search: {
        isShare: '',
        isUse: ''
      }, //查询数据
      tableLoading: false, //表格loading
      formData: {
        autoSync: '0' //自动同步
      },
      excelModal: false,
      excelColumns:[
        {
          title: '文件名称',
          key: 'fileName',
          align: 'left',
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ],
      excelTableData:[],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        //表格字段
        {
          title: '课程名称',
          key: 'name',
          align: 'left',
          minWidth: 240,
          tree: true,
          slot: 'name'
        },
        {
          title: '课程分类',
          key: 'articleColumnName',
          align: 'center',
          minWidth: 180,
          render(h, params) {
            let text = params.row.articleColumnName;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text
                ),
                h('span', { slot: 'content' }, text)
              ]
            );
          }
        },
        {
          title: '课程类型',
          slot: 'articleType',
          align: 'center',
          minWidth: 100
        },
        {
          title: '来源',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sourceFrom = params.row.sourceFrom;
            switch (sourceFrom) {
              case 0:
                return <span>素材库</span>;
              default:
                return <span>自建</span>;
            }
          }
        },
        {
          title: '是否可分享',
          slot: 'isShare',
          align: 'center',
          minWidth: 120
        },
        {
          title: '是否上架',
          slot: 'isUse',
          align: 'center',
          minWidth: 120
        },
        {
          title: '最后更新人',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const userName = params.row.userName;
            return <span>{userName ? userName : '-'}</span>;
          }
        },
        {
          title: '上架时间',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            const useTime = params.row.useTime;
            return <span>{useTime ? filterTime(useTime, 'YYYY-MM-DD HH:mm') : '-'}</span>;
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 280,
          fixed: 'right'
        }
      ],
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 10, //页容量
      pageNum: 1, //当前页
      form: {}, //表单数据
      formVisible: false, //表单弹窗
      selectIds: [],
      selectArr: [],
      isAll: false //全选
    };
  },
  activated(){
    this.searchAjax();
    this.getAutoSyncDetail();
    this.getMenuList();
    this.getProductList();
  },
  created() {
    for (const key in this.search) {
      if (Object.hasOwnProperty.call(this.search, key)) {
        this.search[key] = '';
      }
    }
    this.articleType = JSON.parse(localStorage.dic)['TRAIN_ARTICLE_TYPE'];
    if (this.articleType) {
      for (let key in this.articleType) {
        this.articleTypeList.push({
          id: key,
          name: this.articleType[key]
        });
      }
    }
    if(!this.$units.pointAction('content_4_1_1')&&!this.$units.pointAction('content_4_1_2')&&!this.$units.pointAction('content_4_1_3')&&!this.$units.pointAction('content_4_1_4')){
    	this.columns.splice(this.columns.length-1, 1)
    }
  },
  methods: {
    // 获取是否自动同步详情
    getAutoSyncDetail() {
      this.$http({
        url: `/buz/courseSyncConfiguration/query/detail`,
        type: 'POST',
        data: {}
      }).then(res => {
        if (res.data) {
          if(!res.data.autoSync) {
            res.data.autoSync = '0'
          }
          this.formData = res.data;
        }
      });
    },

    // 产品
    getProductList() {
      this.$http({
        url: '/buz/productBase/read/short/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 9999
        }
      }).then(res => {
        this.productListArr = res.data;
      });
    },

    disabledMethod(row) {
      let tmp = false;
      if (row.parentId) {
        let res = this.tableData.find(i => i.id == row.parentId);
        res.isUse == 0 ? (tmp = true) : false;
      }
      return tmp;
    },
    getMenuList() {
      this.$http({
        url: `/buz/courseColumn/read/list`,
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        if (res.data && res.data.length) {
          this.menuList = res.data;
        }
      });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._checked = status;
        if (status) {
          item._disabled = true;
        } else {
          this.getList();
        }
        item.children &&
          item.children.forEach(itemChild => {
            itemChild._checked = status;
            if (status) {
              itemChild._disabled = true;
            } else {
              this.getList();
            }
          });
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 是否分享
    changeShare(item) {
      this.$http({
        url: `/buz/course/updateShareStatus/${item.id}`,
        type: 'POST',
        data: {
          isShare: item.isShare
        },
        apiPermissionCode: 'operate_3_1_5'
      })
        .then(res => {
          this.$notice.success('修改成功');
        })
        .catch(() => {
          item.isShare = item.isShare == '0' ? '1' : '0';
        });
    },
    // 是否上架
    changeUse(item) {
      this.$http({
        url: `/buz/course/updateUseStatus/${item.id}`,
        type: 'POST',
        data: {
          isUse: item.isUse
        },
        apiPermissionCode: ''
      })
        .then(res => {
          this.$notice.success('修改成功');
          this.getList();
        })
        .catch(() => {
          item.isUse = item.isUse == '0' ? '1' : '0';
        });
    },
    // 删除模板
    delTemplate(item) {
      if (item.isUse != 0) {
        this.$notice.error('请下架后再删除');
        return;
      }
      this.$notice.inquiry('确定删除课程？').then(() => {
        this.$http({
          url: '/buz/course/del',
          type: 'get',
          data: {
            id: item.id
          },
          apiPermissionCode: ''
        }).then(res => {
          this.$notice.success('删除课程成功');
          this.searchAjax();
        });
      });
    },
    // 打开模板编辑或新增弹窗
    openTemplateEdit(item) {
      this.$refs.editCourse.open(item || {});
    },
    // 从公共素材库导入
    toPublicMaterialsPage() {
      this.$router.push({
        path: '/contentManagement/publicMaterialLibrary',
        query: {
          typeIndex: 3,
          time:JSON.stringify(new Date())
        }
      });
    },
    addChildrenTemplate(item) {
      if (!item.articleType || !item.articleColumnIds) {
        return this.$notice.error('您还没有设置课程分类');
      }
      let data = {
        id: '',
        parentId: item.id,
        articleType: item.articleType,
        articleColumnIds: item.articleColumnIds,
        orgList: item.orgList
      };
      this.$refs.editCourse.open(data || {});
    },
    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.search);
      if (params.time && params.time[0]) {
        params.beginTime = filterTime(params.time[0], 'YYYY-MM-DD');
        params.endTime = filterTime(params.time[1], 'YYYY-MM-DD');
        delete params.time;
      } else {
        delete params.time;
      }
      return params;
    },
    reset() {
      for (const key in this.search) {
        if (Object.hasOwnProperty.call(this.search, key)) {
          this.search[key] = '';
        }
      }
      delete this.search.time;
      this.pageNum = 1;
      this.getList();
    },
    searchAjax() {
      this.pageNum = 1;
      this.isAll = false;
      this.selectIds = [];
      this.selectArr = [];
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableLoading = true;
      this.$http({
        url: '/buz/course/read/list',
        type: 'post',
        data: params,
        apiPermissionCode: ''
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data.map(item => {
            // 一级
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (item.children) {
              item._showChildren = true;
            }
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
            // 子集
            item.children &&
              item.children.forEach(itemChild => {
                this.selectArr.forEach(item2 => {
                  if (itemChild.id == item2.id) {
                    itemChild._checked = true;
                  }
                });
                if (itemChild.children) {
                  itemChild._showChildren = true;
                }
                if (this.isAll) {
                  itemChild._checked = true;
                  itemChild._disabled = true;
                }
              });
            return item;
          });
          this.total = res.total;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },
    changeSync(value) {
      this.formData.autoSync = value;
      this.$http({
        url: '/buz/courseSyncConfiguration/edit',
        type: 'POST',
        data: this.formData
      });
    },
    // 列表选中
    onSelectChange(arr) {
      this.selectIds = arr.map(item => item.id);
      // 处理分页已选中数据回显
      const ids = arr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
        // 处理二级选中
        item.children &&
          item.children.forEach(itemChild => {
            if (ids.includes(itemChild.id) && !selectIds.includes(itemChild.id)) {
              //未添加已勾选的数据时添加数据
              this.selectArr.push(itemChild);
              selectIds.push(itemChild.id);
            } else if (!ids.includes(itemChild.id) && selectIds.includes(itemChild.id)) {
              //添加了未勾选的数据时删除
              this.selectArr.splice(selectIds.indexOf(itemChild.id), 1);
              selectIds.splice(selectIds.indexOf(itemChild.id), 1);
            }
          });
      });
    },
    // 批量删除
    batchDelete() {
      if (!this.selectIds.length && !this.isAll) {
        this.$notice.msg('请至少选择一个课程');
        return;
      }
      this.selectIds = this.selectArr.map(item => item.id);
      let data = {};
      if (this.isAll) {
        data.selectAll = 1;
      } else {
        data.selectAll = 0;
        data.ids = this.selectIds;
      }
      this.$notice.inquiry('确定批量下架并删除课程').then(() => {
        this.tableLoading = true;
        this.$http({
          url: '/buz/course/bath/del',
          type: 'POST',
          data,
          apiPermissionCode: ''
        }).then(res => {
          this.tableLoading = false;
          this.$notice.success('删除成功');
          this.getList();
        });
      });
    },
    // 预览
    preview(row) {
      if(row.articleType == 5){
        if(row.fileList.length == 1){
          window.open(row.fileList[0].url, "_blank");
        }else{
          this.excelModal = true;
          this.excelTableData = row.fileList;
        }
      }else{
        this.openPageTabTags(
            '/trainingCourse/coursePreview', 
            { 
                url: row.url
            }
        );
      }
    },
    // excel下载
    downloadExcel(row) {
      window.open(row.url, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
